import { Component, Element, h, Listen, Prop } from '@stencil/core';
import {
	Breakpoint,
	getCurrentBreakpoint,
} from '../../ishares/web-components/_helpers/breakpoints';
import debounce from '../../common/_helpers/debounce';
import isChromatic from 'chromatic/isChromatic';
import {
	moveInlineStylesToHead,
	removeInlineStylesFromHead,
} from '../../ishares/web-components/_helpers/content-security-policy';

@Component({
	tag: 'ds-integration-banner',
})
export class CampaignBanner {
	@Element() el: HTMLDsCampaignBannerElement;
	previousBreakpoint: Breakpoint;
	currentBreakpoint: Breakpoint;
	currentTextContainerHeight: number;
	previousTextContainerHeight: number;

	@Prop() smallImageAlt: string;
	@Prop() imageAlt: string;

	@Listen('resize', { target: 'window' })
	async windowResizeHandler() {
		if (!isChromatic()) {
			this.setBgHeightWithDelay();
		}
	}

	getTextContainerHeight(): number {
		return this.el.querySelector('div.ds-tile-container').clientHeight;
	}

	setBgHeight = (): void => {
		this.currentBreakpoint = getCurrentBreakpoint();
		this.currentTextContainerHeight = this.getTextContainerHeight();

		const imageEl: HTMLElement = this.el.querySelector('img');

		switch (this.currentBreakpoint) {
			case Breakpoint.XS:
			case Breakpoint.SM:
				if (this.smallImageAlt) imageEl.setAttribute('alt', this.smallImageAlt);
				else imageEl.setAttribute('alt', this.imageAlt);
				break;
			case Breakpoint.MD:
			case Breakpoint.LG:
			case Breakpoint.XL:
				imageEl.setAttribute('alt', this.imageAlt);
				break;
		}

		this.previousBreakpoint = this.currentBreakpoint;
		this.previousTextContainerHeight = this.currentTextContainerHeight;
		moveInlineStylesToHead(this.el.id);
	};

	setBgHeightWithDelay = debounce(this.setBgHeight, 150);

	componentDidLoad() {
		this.previousBreakpoint = this.previousBreakpoint || getCurrentBreakpoint();
		this.currentBreakpoint = getCurrentBreakpoint();
		this.previousTextContainerHeight =
			this.previousTextContainerHeight || this.getTextContainerHeight();
		this.currentTextContainerHeight = this.getTextContainerHeight();
		if (!isChromatic()) {
			this.setBgHeight();
		}
	}

	disconnectedCallback() {
		removeInlineStylesFromHead(this.el.id);
	}

	render() {
		return <slot />;
	}
}
